import createDuck from 'lib/ducks/remoteDuck'
import Products from 'lib/api/products'

export default createDuck({
  namespace: 'account',
  store: 'cartRecommendations',
  fetchCallback: (options) => Products.getUpSellsByProduct(options),
})
